<template>
<div class="wrap">

    <el-dialog
      class="importModal"
      title="批量导入"
      :visible.sync="modalInfo.isShow"
      :close-on-click-modal="false"
      v-if="modalInfo.isShow"
      width="640px"
    >
      <div style="margin: 10px;">
        <el-upload
          ref="newupload"
          class="upload-demo"
          drag
          multiple
          accept=".xls,.xlsx"
          :file-list="fileList"
          action="/hcm/hcmShop/readExcelFile"
          :before-upload="beforeUpload"
          :auto-upload="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <p>点击这里选择文件上传</p>
            <p>支持扩展名：.xls .xlsx</p>
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" class="confirm" @click="confirmClick()" :loading="confirmDisabled">确 定</el-button>
        <el-button size="small" class="cancel" @click="noConfirmClick()">取 消</el-button>
      </div>
    </el-dialog>


  <!-- 导入报错 -->
  <importErrorResult :modalInfo="modalInfoErrs" :tableData="tableDataErr" :columsData="columsDataErr"/>
</div>

</template>
<script>
import importErrorResult from "components/importErrorResult";  //导入报错
import axios from "axios";
export default {
  name: "importModal",
  components:{importErrorResult},
  props: {
    modalInfo: {
      type: Object,
      default: () => {}
    },
    columsDataErr:{
      type:Array
    }
  },
  data() {
    return {
      confirmDisabled: false,
      fileList:[],
      modalInfoErrs:{isShow:false},//错误信息弹框
      tableDataErr:[],
    };
  },
  methods: {
    noConfirmClick() {
      this.modalInfo.isShow = false
      this.confirmDisabled = false
    },
    beforeUpload(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (['xls','xlsx'].indexOf(FileExt.toLowerCase()) == -1){
        this.$message({
          type: 'warning',
          message: '请上传后缀名为xlsx或xls的附件！'
        });
        return false;
      }
      this.confirmDisabled = true
      let _this = this;
      let fd = new FormData();
      fd.append("file", file);
      fd.append("shoptype", this.modalInfo.shoptype);
      if(!this.modalInfo.shoptype) fd.delete('shoptype')
      const instance=axios.create({
        headers:{
          "Content-Type": "multipart/form-data"
        },
        timeout: (60 * 1000)*5,
      })
      instance.post(this.modalInfo.url, fd).then(function(res) {
        if (res.data.status == "10000") {
          if (res.data.data&&res.data.data.length > 0) {
            _this.modalInfoErrs = { isShow:true,reminder:res.data.message}
            let dataErr = []
            dataErr = res.data.data
            console.log(dataErr)
            if (dataErr.length > 0) {
              for (let a in dataErr) {
                if (dataErr[a]) {
                  dataErr[a].level = _this.levelData(dataErr[a].level)
                }
              }
            }
             _this.tableDataErr = dataErr

            _this.confirmDisabled = false
            _this.modalInfo.isShow = false
            _this.$emit("reqTableData")
          } else {
            _this.modalInfo.isShow = false;
            _this.confirmDisabled = false
            _this.$emit("reqTableData")
            _this.$message.success(res.data.message);
          }
        } else {
          _this.$message.error(res.data.message);
          _this.confirmDisabled = false
        }
      });
      return false;
    },
    levelData(value) {
        value = Number(value);
        if(value == 1) return '一级经销商'
        else if(value == 2) return '二级经销商'
        else if(value == 3) return '三级经销商'
        else if(value == 4) return '四级经销商'
        else if(value == 5) return '五级经销商'
    },
    confirmClick() {
      this.$refs.newupload.submit();
      // setTimeout(() => {
      //   this.modalInfo.isShow = false
      // }, 4000);
    }
  }
};
</script>
<style lang="scss">
</style>
